import React, { useState, useEffect } from 'react';
import { setSelectedPickupData } from '../../../../../redux/checkoutredux/actions/checkoutactions/checkoutActions'; // Import der Versand-Aktion

const BlockPickup = ({ store, pickuplocations, shippingmethods }) => {
  const [selectedLocation, setSelectedLocation] = useState(null);

  const handleLocationChange = (index, locationname) => {
    const pickupMethod = { index: index, locationname: locationname };

    
   // store.dispatch(setPickupCurrent(index));
    store.dispatch(setSelectedPickupData(pickupMethod));

    setSelectedLocation(index);
    console.log("Selected: ",index);
  };


  //Vorauswahl - default
  useEffect(() => {
   // let pickupcurrentLocation = store.getState().pickupcurrent.locationcurrent;
   // let pickupcurrentLocation = store.getState().selectedorderdata.pickupdata.index;
    let pickupcurrentLocation = store.getState().selectedorderdata.pickupdata?.index || 0;
    setSelectedLocation(pickupcurrentLocation);
    console.log("Selected start1: ",pickupcurrentLocation);

    // Wenn kein Standort ausgewählt ist, wähle automatisch den ersten Standort aus
   // if (pickupcurrentLocation === null && pickuplocations.pickupLocations.length > 0) {
    if (pickupcurrentLocation === null && pickuplocations.length > 0) {
      console.log("Page reload first select");
      const pickupMethod = { index: 0, locationname: "" };
      store.dispatch(setSelectedPickupData(pickupMethod));
     // store.dispatch(setPickupCurrent(0));
      setSelectedLocation(0); // Wähle den Index des ersten Elements aus
    }
  }, []);

  // Effekt zum Wiederherstellen des ausgewählten Standorts beim Rendern
  useEffect(() => {
   // let pickupcurrentLocation = store.getState().pickupcurrent.locationcurrent;
    //let pickupcurrentLocation = store.getState().selectedorderdata.pickupdata.index;
    let pickupcurrentLocation = store.getState().selectedorderdata.pickupdata?.index || 0;
    setSelectedLocation(pickupcurrentLocation);
    console.log("Selected start2: ",pickupcurrentLocation);
    // Prüfe, ob ein ausgewählter Standort gespeichert ist
    //if (selectedLocation !== null && pickuplocations.pickupLocations.length > 0) {
    if (selectedLocation !== null && pickuplocations.length > 0) {
      // Selektiere den entsprechenden Radio-Button
      document.getElementById(`pickupLocation${pickupcurrentLocation}`).checked = true;
    }
  }, [selectedLocation]); // Führe den Effekt bei Änderungen von selectedLocation aus

  return (
    <div id="ips-pickup-details" className="ips-module">
      <div className="row g-3">
        <div className="list-group">
          {//pickuplocations.pickupLocations.map((location, index) => (
            pickuplocations.map((location, index) => (
            <label className="list-group-item ips-checkout-deliverymethod-select" key={index}>
              <div className="row">
                <div className="col-6">
                  <div className="row g-3">
                    <div className="col-2 d-flex align-items-center justify-content-center">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="pickupLocation"
                          id={`pickupLocation${index}`}
                          value={location[0]['ips-mb-localpickup-mainlocationname']}
                          checked={selectedLocation === index}
                          onChange={() => handleLocationChange(index, location[0]['ips-mb-localpickup-mainlocationname'])}
                        />
                      </div>
                    </div>
                    <div className="col-10">
                      <div className="row flex pb-2 ips-checkout-bold-title" htmlFor={`pickupLocation${index}`}>
                        {location[0]['ips-mb-localpickup-mainlocationname']}
                      </div>
                      <div className="row flex">
                        {location[0]['ips-mb-localpickup-addresstext'].split('\r\n').map((line, index) => (
                          <React.Fragment key={index}>{line}<br /></React.Fragment>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="row flex pb-2" htmlFor={`pickupLocation${index}`}>
                    {location[0]['ips-mb-localpickup-estimatetimetext']}
                  </div>
                  <div className="row flex">
                    {location[0]['ips-mb-localpickup-instructiontext'].split('\r\n').map((line, index) => (
                      <React.Fragment key={index}>{line}<br /></React.Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </label>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BlockPickup;